/*
 * Taken from react textarea autosize component
 * Reference: https://github.com/Andarist/react-textarea-autosize
 */

const SIZING_STYLE = [
  'borderBottomWidth',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'boxSizing',
  'fontFamily',
  'fontSize',
  'fontStyle',
  'fontWeight',
  'letterSpacing',
  'lineHeight',
  'paddingBottom',
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'tabSize',
  'textIndent',
  'textRendering',
  'textTransform',
  'width',
  'wordBreak'
]

const HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
}

const pick = (props, obj) =>
  props.reduce((acc, prop) => {
    acc[prop] = obj[prop]
    return acc
  }, {})

export const forceHiddenStyles = node => {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(key => {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important')
  })
}

export const getSizingData = node => {
  const style = window.getComputedStyle(node)

  if (style === null) {
    return null
  }

  const sizingStyle = pick(SIZING_STYLE, style)
  const { boxSizing } = sizingStyle

  if (boxSizing === '') {
    return null
  }

  const paddingSize =
    parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop)

  const borderSize =
    parseFloat(sizingStyle.borderBottomWidth) +
    parseFloat(sizingStyle.borderTopWidth)

  return {
    sizingStyle,
    paddingSize,
    borderSize
  }
}

let hiddenTextarea = null

const getHeight = (node, sizingData) => {
  const height = node.scrollHeight

  if (sizingData.sizingStyle.boxSizing === 'border-box') {
    return height + sizingData.borderSize
  }

  return height - sizingData.paddingSize
}

export const calculateNodeHeight = (
  sizingData,
  value,
  minRows = 1,
  maxRows = Infinity
) => {
  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea')
    hiddenTextarea.setAttribute('tabindex', '-1')
    hiddenTextarea.setAttribute('aria-hidden', 'true')
    forceHiddenStyles(hiddenTextarea)
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea)
  }

  const { paddingSize, borderSize, sizingStyle } = sizingData
  const { boxSizing } = sizingStyle

  Object.keys(sizingStyle).forEach(key => {
    hiddenTextarea.style[key] = sizingStyle[key]
  })

  forceHiddenStyles(hiddenTextarea)

  hiddenTextarea.value = value
  let height = getHeight(hiddenTextarea, sizingData)

  hiddenTextarea.value = 'x'
  const rowHeight = hiddenTextarea.scrollHeight - paddingSize

  let minHeight = rowHeight * minRows
  if (boxSizing === 'border-box') {
    minHeight = minHeight + paddingSize + borderSize
  }
  height = Math.max(minHeight, height)

  let maxHeight = rowHeight * maxRows
  if (boxSizing === 'border-box') {
    maxHeight = maxHeight + paddingSize + borderSize
  }
  height = Math.min(maxHeight, height)

  return [height, rowHeight]
}

export function removeHiddenTextarea() {
  if (hiddenTextarea && hiddenTextarea.parentNode) {
    hiddenTextarea.parentNode.removeChild(hiddenTextarea)
  }
}
